import { ListTemplate, QueryStringSearch } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import {
  getListTemplate,
  getListTemplateDetail,
  getListTemplateItem,
} from '../queries';
import { useAuthStore } from '../stores';

type ExtraQueryOptions = {
  enabled?: boolean;
  retry?:
    | number
    | boolean
    | ((failureCount: number, error: unknown) => boolean);
  staleTime?: number;
  gcTime?: number;
};

export function getListTemplateOptions(
  access_token: string,
  params: Readonly<QueryStringSearch>
) {
  return queryOptions<ListTemplate>({
    queryKey: ['ListTemplate', params],
    queryFn: () => getListTemplate(access_token, params),
  });
}

export const useListTemplate = (params: Readonly<QueryStringSearch>) => {
  const session = useAuthStore();
  return useQuery<ListTemplate>(
    getListTemplateOptions(session.access_token, params)
  );
};

export function getListTemplateDetailOptions(
  access_token: string,
  id: string,
  warehouse: string,
  options?: ExtraQueryOptions
) {
  return queryOptions({
    queryKey: ['ListTemplateDetail', id, warehouse],
    queryFn: () => getListTemplateDetail(access_token, id, warehouse),
    enabled: options?.enabled,
    retry: options?.retry,
    staleTime: options?.staleTime,
    gcTime: options?.gcTime,
  });
}

export const useListTemplateDetail = (
  id: string,
  warehouse: string,
  options?: ExtraQueryOptions
) => {
  const session = useAuthStore();
  return useQuery(
    getListTemplateDetailOptions(session.access_token, id, warehouse, options)
  );
};

export function getListTemplateItemOptions(
  access_token: string,
  id: string,
  warehouse: string,
  params: Readonly<QueryStringSearch>,
  options?: ExtraQueryOptions
) {
  return queryOptions({
    queryKey: ['ListTemplateItem', id, warehouse, params],
    queryFn: () => getListTemplateItem(access_token, id, warehouse, params),
    enabled: options?.enabled,
    retry: options?.retry,
    staleTime: options?.staleTime,
    gcTime: options?.gcTime,
  });
}

export const useListTemplateItem = (
  id: string,
  warehouse: string,
  params: Readonly<QueryStringSearch>,
  options?: ExtraQueryOptions
) => {
  const session = useAuthStore();
  return useQuery(
    getListTemplateItemOptions(
      session.access_token,
      id,
      warehouse,
      params,
      options
    )
  );
};
